import type { SiteCopy } from "./en";

export const es = {
    nav: {
      links: [
        { href: "/availability-monitor", label: "Monitor" },
        { href: "/how-it-works", label: "Cómo funciona" },
        { href: "/routes", label: "Rutas" },
        { href: "/pricing", label: "Precio" },
        { href: "/blog", label: "Guías" },
      ],
      createNotification: "Crear alerta",
      dashboard: "Mis alertas",
      homeLabel: "Inicio de MachuPing",
      menuLabel: "Abrir menú",
      switchLanguage: "Inglés",
      switchLanguageHref: "/",
    },
    footer: {
      tagline: "Alertas de disponibilidad para rutas de Machu Picchu difíciles de conseguir.",
      disclaimer: "Servicio independiente. Solo notificaciones; no revendemos entradas.",
      rights: "Todos los derechos reservados.",
      columns: {
        Producto: [
          { href: "/availability-monitor", label: "Monitor de disponibilidad" },
          { href: "/ticket-alerts", label: "Alertas de entradas" },
          { href: "/restock-alerts", label: "Alertas de reapertura" },
          { href: "/availability", label: "Alertas de disponibilidad" },
          { href: "/routes", label: "Rutas compatibles" },
          { href: "/how-it-works", label: "Cómo funciona" },
          { href: "/pricing", label: "Precio" },
        ],
        Recursos: [
          { href: "/blog", label: "Guías" },
          { href: "/faq", label: "Preguntas frecuentes" },
          { href: "/trust", label: "Confianza y seguridad" },
          { href: "/contact", label: "Contacto" },
          { href: "/status", label: "Estado del sistema" },
        ],
        Legal: [
          { href: "/privacy", label: "Privacidad" },
          { href: "/terms", label: "Términos" },
        ],
      },
    },
    home: {
      metadataTitle: "Alertas y reaperturas de entradas a Machu Picchu",
      metadataDescription:
        "Recibe alertas por email cuando aparezca disponibilidad para Machu Picchu. Elige fechas exactas, rutas y grupo; compra en el proveedor oficial.",
      badge: "Creado para días agotados",
      title: "¿Machu Picchu agotado? Te avisamos cuando vuelvan las entradas.",
      description:
        "Las cancelaciones y reaperturas ocurren constantemente. MachuPing vigila tus fechas y rutas exactas, y te envía un email en cuanto aparecen lugares — tú compras en el proveedor oficial.",
      heroCta: "Configura tu alerta",
      secondaryCta: "Ver rutas compatibles",
      stats: {
        routesMonitored: "Rutas monitoreadas",
        notificationSpeed: "Velocidad de aviso",
        monitoring: "Monitoreo",
        openingsCaught: "Reaperturas (7d)",
        alertsSent: "emails enviados",
      },
      setupTitle: "Configura tu alerta",
      setupDescription: "Elige rutas, fechas y tamaño del grupo. Podrás revisar todo antes de pagar.",
      setupCta: "Continuar",
      stepsTitle: "Cómo funciona",
      steps: [
        { step: "1", title: "Elige tus rutas", description: "Selecciona cada ruta y horario que aceptarías." },
        { step: "2", title: "Define preferencias", description: "Añade fechas exactas y tamaño del grupo, y paga desde $9." },
        { step: "3", title: "Recibe aviso y compra", description: "Te avisamos en cuanto se abre — compra en el proveedor oficial." },
      ],
      fullFlow: "Ver el flujo completo",
      whyBadge: "Por qué MachuPing",
      whyTitle: "Pensado para ventanas cortas de disponibilidad",
      why: [
        { title: "Alertas rápidas por email", description: "Revisamos con frecuencia y te avisamos en minutos cuando aparece inventario compatible." },
        { title: "Exactamente lo que reservarías", description: "Elige las rutas, horarios, fechas y tamaño del grupo que aceptarías. Solo avisamos con coincidencias reales." },
        { title: "Solo notificaciones", description: "Nunca retenemos ni revendemos entradas. Compras directamente en el proveedor oficial." },
        { title: "Desde $9", description: "$9 por un viajero, +$3 por viajero adicional, hasta $18. Un solo pago, sin suscripción." },
      ],
      proofTitle: "Míralo funcionando ahora mismo",
      proofDescription: "Datos en vivo de nuestro monitor: aperturas recientes, cupos actuales y las últimas revisiones.",
      bottomTitle: "Deja de refrescar. Empieza a recibir alertas.",
      bottomDescription: "Crea una alerta enfocada para tus rutas y fechas, y deja que vigilemos por ti.",
      bottomCta: "Configura tu alerta",
      bottomSecondaryCta: "Ver precio",
    },
    alertSetup: {
      eyebrow: "Configura tu alerta",
      routesLabel: "¿Qué rutas te sirven?",
      selectAll: "Seleccionar todas",
      clearAll: "Borrar todas",
      selectGroup: "Seleccionar todas",
      backupHint: "Elige todas las rutas que aceptarías — más chances. Seguimos avisando hasta que pasen tus fechas o pauses la alerta.",
      editRoutes: "Editar rutas",
      hideRoutes: "Listo",
      datesLabel: "¿Cuándo quieres ir?",
      datesHint: "Elige tu fecha principal. Agrega alternativas si tus planes son flexibles: vigilamos todas las fechas que elijas.",
      travelDate: "Fecha de viaje",
      backupDate: "Fecha alternativa",
      addBackupDate: "Agregar una fecha alternativa",
      pickDate: "Elige una fecha",
      partyLabel: "¿Cuántas entradas?",
      partyHint: "Solo te avisamos cuando se abren esa cantidad de cupos juntos.",
      setupSummary: "Tu alerta",
      routes: "Rutas",
      chooseRoute: "Elige una ruta",
      party: "Entradas",
      ticket: "entrada",
      tickets: "entradas",
      addPartySize: "Añade el tamaño del grupo",
      dates: "Fechas",
      chooseDate: "Agrega una fecha",
      delivery: "Entrega",
      deliveryDetail: "Alertas por email después de iniciar sesión",
      configured: "Todo listo — guarda para empezar a vigilar.",
      finishChoices: "Agrega una fecha para empezar.",
      chooseDateCta: "Elige una fecha para continuar",
      reviewBeforePayment: "Sin cargo hasta que revises y confirmes — luego desde $9, sin suscripción.",
      askBeforeSignin: "¿Tienes una pregunta antes de iniciar sesión?",
      bookingTips: "Consejos para reservar apenas te enviemos el email",
      edit: "Editar",
      done: "Listo",
      allRoutes: "Todas las rutas",
      routesSelected: "{count} rutas",
    },
    bookingReadiness: {
      title: "Prepárate para comprar antes de que llegue tu alerta",
      description: "Los cupos pueden desaparecer en minutos. Un poco de preparación ahora te permite comprar apenas te enviemos el email.",
      guideCta: "Leer el checklist completo",
      steps: [
        "Crea o inicia sesión en tu cuenta oficial de TuBoleto (tuboleto.cultura.pe) con anticipación.",
        "Verifica el email de tu cuenta para que nada te bloquee al iniciar sesión.",
        "Ten listos el pasaporte y el nombre completo de cada viajero, además de una tarjeta de pago válida.",
        "Cuando llegue nuestro email de alerta, abre el enlace de compra y paga de inmediato — el inventario puede desaparecer rápido.",
      ],
    },
    restockProof: {
      title: "Estado del monitoreo",
      status: {
        operational: {
          label: "En vivo",
          headline: "Estamos buscando entradas ahora mismo",
          sub: "Las revisiones funcionan con normalidad. Te enviaremos un email en cuanto se abran cupos nuevos.",
        },
        degraded: {
          label: "Con leve retraso",
          headline: "Las revisiones van un poco atrasadas",
          sub: "Seguimos vigilando, pero la última revisión es más antigua de lo habitual: la disponibilidad de abajo puede ir por detrás del sitio oficial.",
        },
        stale: {
          label: "Poniéndose al día",
          headline: "Nuestras revisiones se están poniendo al día",
          sub: "El monitoreo va atrasado por ahora. Trata la disponibilidad de abajo como histórica hasta que se actualice.",
        },
        unknown: {
          label: "Iniciando",
          headline: "El monitoreo se está configurando",
          sub: "Todavía no se completó ninguna revisión. Confirma en el sitio oficial antes de confiar en los datos de abajo.",
        },
      },
      lastCheckedPrefix: "Última revisión",
      metrics: {
        available: {
          label: "Horarios monitoreados con cupos",
          help: "Cupos que vemos en este momento en las fechas que monitoreamos.",
        },
        opened7d: {
          label: "Veces que se abrieron entradas",
          help: "Con qué frecuencia aparecieron cupos nuevos en los últimos 7 días.",
        },
        lastOpened: {
          label: "Última vez que se abrieron entradas",
          help: "Cuándo vimos por última vez cupos nuevos disponibles.",
        },
        lastChecked: {
          label: "Última revisión",
          help: "Cuándo miramos por última vez el sitio oficial.",
        },
      },
      slotsWithStock: "Horarios monitoreados con cupos",
      nearestTitle: "Entradas que puedes conseguir ahora",
      nearestSub: "Cupos abiertos que estamos viendo en próximas fechas.",
      noCached: "No hay cupos abiertos ahora mismo: te avisaremos por email en cuanto aparezcan.",
      recentTitle: "Abiertas recientemente",
      recentSub: "Cupos nuevos que detectamos hace poco.",
      opening: "apertura",
      openings: "aperturas",
      last24h: "en las últimas 24 h",
      noIncreases: "Todavía no se detectaron cupos nuevos.",
      noneYet: "Todavía ninguna",
      starting: "Iniciando",
      seat: "cupo",
      seats: "cupos",
      at: "a las",
      scope: "disponibilidad de Machu Picchu",
    },
    emails: {
      subject: "Disponibilidad para Machu Picchu: {date} {slot}",
      found: "MachuPing encontró disponibilidad.",
      route: "Ruta",
      date: "Fecha",
      slot: "Horario",
      seatsObserved: "Cupos observados",
      book: "Comprar en el proveedor oficial",
    },
  } as const satisfies SiteCopy;
